// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) Microsoft Corporation.
   Licensed under the MIT license. */

.video-recording-container {
  position: relative;
}

/* Glassmorphic webcam card - top right floating */
.video-preview-wrapper {
  position: fixed;
  top: 80px;
  right: 28px;
  width: 300px;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(14, 22, 19, 0.55);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45), 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 100;
}

.video-preview {
  width: 100%;
  height: 190px;
  object-fit: cover;
  background:
    radial-gradient(120px 140px at 50% 38%, #2a3d38, #14211d 70%),
    linear-gradient(160deg, #182721, #0c1512);
  display: block;
  /* Mirror video for better user experience (selfie view) */
  transform: scaleX(-1);
}

.recording-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  z-index: 10;
  font-weight: 500;
}

.recording-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(46, 230, 166, 0.15);
  border-top-color: #2ee6a6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Corner badge - "Cam" indicator */
.recording-corner-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(0, 0, 0, 0.35);
  padding: 3px 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  z-index: 2;
}

/* Footer section with LIVE indicator */
.video-preview-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  background: rgba(14, 22, 19, 0.6);
}

.recording-live-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #5dffc0;
  letter-spacing: 0.04em;
}

.recording-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #5dffc0;
  box-shadow: 0 0 0 3px rgba(93, 255, 192, 0.18);
  animation: pulse-green 1.6s infinite;
}

@keyframes pulse-green {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.recording-candidate-name {
  font-size: 12.5px;
  color: #8fa39b;
  font-weight: 500;
}


/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .video-preview-wrapper {
    top: 70px;
    right: 12px;
    width: 220px;
  }

  .video-preview {
    height: 140px;
  }

  .recording-corner-badge {
    font-size: 10px;
    padding: 2px 6px;
  }

  .video-preview-footer {
    padding: 8px 10px;
  }

  .recording-live-tag {
    font-size: 10px;
  }

  .recording-candidate-name {
    font-size: 11px;
  }

  .recording-dot {
    width: 5px;
    height: 5px;
  }
}

/* Tablet adjustments */
@media (min-width: 769px) and (max-width: 1024px) {
  .video-preview-wrapper {
    width: 260px;
  }

  .video-preview {
    height: 165px;
  }
}

/* High resolution displays */
@media (min-width: 1920px) {
  .video-preview-wrapper {
    width: 340px;
  }

  .video-preview {
    height: 216px;
  }
}

/* Dark theme compatibility */
@media (prefers-color-scheme: dark) {
  .video-preview-wrapper {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  }
}

/* Accessibility - reduce motion */
@media (prefers-reduced-motion: reduce) {
  .recording-dot {
    animation: none;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/VideoProctoring/VideoProctoring.css"],"names":[],"mappings":"AAAA;oCACoC;;AAEpC;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C,yEAAyE;EACzE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB;;6CAE2C;EAC3C,cAAc;EACd,0DAA0D;EAC1D,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;;AAGA,sCAAsC;AACtC;EACE;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":["/* Copyright (c) Microsoft Corporation.\n   Licensed under the MIT license. */\n\n.video-recording-container {\n  position: relative;\n}\n\n/* Glassmorphic webcam card - top right floating */\n.video-preview-wrapper {\n  position: fixed;\n  top: 80px;\n  right: 28px;\n  width: 300px;\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(14, 22, 19, 0.55);\n  backdrop-filter: blur(18px) saturate(140%);\n  -webkit-backdrop-filter: blur(18px) saturate(140%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45), 0 2px 8px rgba(0, 0, 0, 0.3);\n  z-index: 100;\n}\n\n.video-preview {\n  width: 100%;\n  height: 190px;\n  object-fit: cover;\n  background:\n    radial-gradient(120px 140px at 50% 38%, #2a3d38, #14211d 70%),\n    linear-gradient(160deg, #182721, #0c1512);\n  display: block;\n  /* Mirror video for better user experience (selfie view) */\n  transform: scaleX(-1);\n}\n\n.recording-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 13px;\n  z-index: 10;\n  font-weight: 500;\n}\n\n.recording-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid rgba(46, 230, 166, 0.15);\n  border-top-color: #2ee6a6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Corner badge - \"Cam\" indicator */\n.recording-corner-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.75);\n  background: rgba(0, 0, 0, 0.35);\n  padding: 3px 8px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  z-index: 2;\n}\n\n/* Footer section with LIVE indicator */\n.video-preview-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n  background: rgba(14, 22, 19, 0.6);\n}\n\n.recording-live-tag {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #5dffc0;\n  letter-spacing: 0.04em;\n}\n\n.recording-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #5dffc0;\n  box-shadow: 0 0 0 3px rgba(93, 255, 192, 0.18);\n  animation: pulse-green 1.6s infinite;\n}\n\n@keyframes pulse-green {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n}\n\n.recording-candidate-name {\n  font-size: 12.5px;\n  color: #8fa39b;\n  font-weight: 500;\n}\n\n\n/* Responsive adjustments for mobile */\n@media (max-width: 768px) {\n  .video-preview-wrapper {\n    top: 70px;\n    right: 12px;\n    width: 220px;\n  }\n\n  .video-preview {\n    height: 140px;\n  }\n\n  .recording-corner-badge {\n    font-size: 10px;\n    padding: 2px 6px;\n  }\n\n  .video-preview-footer {\n    padding: 8px 10px;\n  }\n\n  .recording-live-tag {\n    font-size: 10px;\n  }\n\n  .recording-candidate-name {\n    font-size: 11px;\n  }\n\n  .recording-dot {\n    width: 5px;\n    height: 5px;\n  }\n}\n\n/* Tablet adjustments */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .video-preview-wrapper {\n    width: 260px;\n  }\n\n  .video-preview {\n    height: 165px;\n  }\n}\n\n/* High resolution displays */\n@media (min-width: 1920px) {\n  .video-preview-wrapper {\n    width: 340px;\n  }\n\n  .video-preview {\n    height: 216px;\n  }\n}\n\n/* Dark theme compatibility */\n@media (prefers-color-scheme: dark) {\n  .video-preview-wrapper {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n  }\n}\n\n/* Accessibility - reduce motion */\n@media (prefers-reduced-motion: reduce) {\n  .recording-dot {\n    animation: none;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
